import da from './languages/da.js'
import en from './languages/en.js'
export default {
    default: 'da',
    da: da,
    en: en
}
